import { connector } from "../../common/connector";

export const defaultItem = {
    id: 0,
    nombre: "",
    email: "",
    password: "password",
    estado: true,
    tiendas_p_v: []
}

export const reducer = (state, action) => {
    switch (action.type) {
        case 'FILL':
            return action.payload;

        case 'ADD':
            return [...state, action.payload];

        case 'UPDATE':
            return state.map(it => {
                if(it.id === action.payload.id) { return action.payload; }
                else { return it; }
            });

        case 'REMOVE':
            return state.filter(it => it.id != action.payload);

        default: return state;
    }
}

export const getItems = (params) => {
    return connector.get('api/usuarios', { params: params });
}

export const createItem = (data) => {
    return connector.post('api/usuarios', data);
}

export const updateItem = (data) => {
    return connector.put(`api/usuarios/${data.id}`, data)
}

export const deleteItem = (id) => {
    return connector.delete(`api/usuarios/${id}`);
}

export const getResources = () => {
    return connector.get(`api/usuarios/resources`);
}

export const updatePuntosVenta = (data) => {
    return connector.post(`api/usuarios/update_puntos_venta`, data);
}


